import { ApiResourceFactory } from '../api.resource.factory'
import { DashboardModel, DashboardListModel, DashboardSaveModel, DashboardRequestModel, ResponseListModel, ResponseModel, SimpleValueModel, ValidationScriptModel, DashboardItemModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IDashboardService {
    getDashboardConfig(): ng.IPromise<DashboardListModel>
    getDashbordItems(request: DashboardRequestModel): ng.IPromise<ResponseListModel<Object>>
    getDashboardTemplates(state?: any): ng.IPromise<DashboardModel[]>
    saveDashboardConfiguration(request: DashboardSaveModel, state?: any): ng.IPromise<ResponseModel>
    validateScript(model: ValidationScriptModel, state?: any): ng.IPromise<any>
    deleteDashboardConfiguration(model: DashboardSaveModel, state?: any): ng.IPromise<ResponseModel>
    getElementData(model: DashboardItemModel, state?: any): ng.IPromise<ResponseListModel<Object>>
}

export class DashboardService implements IDashboardService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getDashboardConfig(): ng.IPromise<DashboardListModel> {
        return this.apiResource.dashboard.get().$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getDashbordItems(request: DashboardRequestModel): ng.IPromise<ResponseListModel<Object>> {
        return this.apiResource.dashboard.query(request).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getDashboardTemplates(state: any = {}) {
        var get = this.apiResource.dashboard['getTemplates']
        state.request = get()
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    saveDashboardConfiguration(request: DashboardSaveModel, state: any = {}) {
        var put = this.apiResource.dashboard.save
        state.request = put(request)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    validateScript(model: ValidationScriptModel, state: any = {}) {
        var post = this.apiResource.dashboard['validateScript']
        state.request = post(model)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteDashboardConfiguration(model: DashboardSaveModel, state: any = {}) {
        let post = this.apiResource.dashboard.delete
        state.request = post(model)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getElementData(model: DashboardItemModel, state: any = {}) {
        let post = this.apiResource.dashboard['getElementData']
        state.request = post(model)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
